import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";

@Component({
	selector: "gl-validation-dialog",
	templateUrl: "./gl-validation-dialog.component.html",
	styleUrls: ["./gl-validation-dialog.component.scss"],
})
export class GlValidationDialogComponent {
	constructor(public dialogRef: MatDialogRef<GlValidationDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

	close() {
		this.dialogRef.close();
	}
}
